<p>
  @if (ec0) {
    @switch (error.code) {
      @case (105) {
        <ng-container i18n>Du musst zuerst eine Entscheidungsfrage definieren.</ng-container>
      }
      @case (110) {
        <ng-container i18n>Es muss mindestens ein Ziel definiert werden.</ng-container>
      }
      @case (111) {
        <ng-container i18n>Jedes Ziel muss einen Namen haben.</ng-container>
      }
      @case (112) {
        <ng-container i18n>Der Typ des Ziels muss gesetzt sein.</ng-container>
      }
      @case (113) {
        <ng-container i18n>Ausprägungen numerischer Ziele müssen Zahlen sein.</ng-container>
      }
      @case (114) {
        <ng-container i18n>Alle Ausprägungen eines Ziels müssen benannt werden.</ng-container>
      }
      @case (115) {
        <ng-container i18n>Verbale Ziele müssen mindestens 2 Ausprägungen haben.</ng-container>
      }
      @case (116) {
        <ng-container i18n>Indikatoren müssen benannt werden.</ng-container>
      }
      @case (117) {
        <ng-container i18n>Ein Indikatorziel muss mindestens einen Indikator haben.</ng-container>
      }
      @case (118) {
        <ng-container i18n>Die Grenzwerte von Indikatoren müssen ein Intervall aufspannen.</ng-container>
      }
      @case (119) {
        <ng-container i18n>Koeffizienten von Indikatoren müssen Zahlen sein.</ng-container>
      }
      @case (120) {
        <ng-container i18n>Bitte benenne den Einflussfaktor.</ng-container>
      }
      @case (121) {
        <ng-container i18n>Einflussfaktoren müssen mindestens 2 Zustände haben.</ng-container>
      }
      @case (122) {
        <ng-container i18n>Die Wahrscheinlichkeiten der Zustände sind ungültig.</ng-container>
      }
      @case (123) {
        <ng-container i18n>Bitte benenne alle Zustände.</ng-container>
      }
      @case (130) {
        <ng-container i18n>Es müssen mindestens zwei Alternativen definiert werden.</ng-container>
      }
      @case (131) {
        <ng-container i18n>Alle Alternativen müssen benannt werden.</ng-container>
      }
      @case (144) {
        <ng-container i18n>Der Nutzen der schlechtesten Ausprägung muss 0 sein.</ng-container>
      }
      @case (145) {
        <ng-container i18n>Der Nutzen der besten Ausprägung muss 100 sein.</ng-container>
      }
      @case (146) {
        <ng-container i18n>Der Nutzen einer Ausprägung muss größer sein als der Nutzen der schlechteren Ausprägung.</ng-container>
      }
      @case (150) {
        <ng-container i18n>Es muss ein Ziel gesetzt werden.</ng-container>
      }
      @case (151) {
        <ng-container i18n>Das ausgewählte Ziel ist ungültig.</ng-container>
      }
      @case (160) {
        <ng-container i18n>Zielgewichtungen müssen mindestens 0 sein.</ng-container>
      }
      @case (161) {
        <ng-container i18n>Zielgewichtungen dürfen höchstens 1000 sein.</ng-container>
      }
      @case (163) {
        <ng-container i18n>Eine Evaluation ist erst dann möglich, wenn die Zielgewichte angegeben wurden.</ng-container>
      }
      @case (164) {
        <ng-container i18n>Für die Evaluation muss mindestens ein Zielgewicht positiv sein.</ng-container>
      }
      @case (170) {
        <ng-container i18n>Alle Ausprägungen müssen gesetzt sein.</ng-container>
      }
      @case (175) {
        <ng-container i18n>Der angegebene Wert ist ungültig</ng-container>
      }
      @case (177) {
        <ng-container i18n>Mehrere Indikatorwerte, obwohl die Skala keine Indikatorskala ist.</ng-container>
      }
      @case (178) {
        <ng-container i18n>Die Anzahl der Werte stimmt nicht mit der Anzahl der Indikatoren überein.</ng-container>
      }
      @case (180) {
        <ng-container i18n>Die Anzahl der Ausprägungen stimmt nicht mit der Anzahl an Alternativen überein.</ng-container>
      }
      @case (186) {
        <ng-container i18n>Die ausgewählten Indikatorwerte resultieren in einem Wert, der außerhalb der Skala liegt.</ng-container>
      }
      @case (200) {
        <ng-container i18n>Bitte besuche zuerst die vorherigen Schritte oder gehe direkt zur Zieleingabe.</ng-container>
      }
      @case (201) {
        <ng-container i18n>Es existiert nur ein Ziel. Überspringe Zielgewichtung.</ng-container>
      }
    }
  }

  @if (ec1) {
    @switch (error.code) {
      @case (140) {
        <ng-container i18n>Ziel „{{ ec1.args[0] }}“ existiert nicht.</ng-container>
      }
      @case (141) {
        <ng-container i18n>Das Ziel „{{ ec1.args[0] }}“ ist nicht definiert.</ng-container>
      }
      @case (142) {
        <ng-container i18n>Die Nutzenfunktion für Ziel „{{ ec1.args[0] }}“ ist ungültig.</ng-container>
      }
      @case (143) {
        <ng-container i18n
          >Die Anzahl der Ausprägungen von Ziel „{{ ec1.args[0] }}“ stimmen nicht mit der Anzahl der Nutzenwerte überein.</ng-container
        >
      }
      @case (162) {
        <ng-container i18n>Du hast noch keinen Trade-off für das Ziel „{{ ec1.args[0] }}“ vorgenommen.</ng-container>
      }
      @case (171) {
        <ng-container i18n>Werte dürfen nicht größer {{ ec1.args[0] }} sein.</ng-container>
      }
      @case (172) {
        <ng-container i18n>Werte dürfen nicht größer {{ ec1.args[0] }} sein.</ng-container>
      }
      @case (173) {
        <ng-container i18n>Werte dürfen nicht kleiner {{ ec1.args[0] }} sein.</ng-container>
      }
      @case (174) {
        <ng-container i18n>Werte dürfen nicht kleiner {{ ec1.args[0] }} sein.</ng-container>
      }
      @case (181) {
        <ng-container i18n
          >Die Anzahl der Ausprägungen stimmt nicht mit der Anzahl der Ziele überein (Alternative „{{ ec1.args[0] }}“).</ng-container
        >
      }
    }
  }

  @if (ec2) {
    @switch (error.code) {
      @case (182) {
        <ng-container i18n>Ausprägung existiert nicht (Alternative „{{ ec2.args[0] }}“, Ziel „{{ ec2.args[1] }}“).</ng-container>
      }
      @case (183) {
        <ng-container i18n
          >Die Anzahl der Werte stimmt nicht mit der Anzahl der Zustände überein (Alternative „{{ ec2.args[0] }}“, Ziel „{{
            ec2.args[1]
          }}“).</ng-container
        >
      }
      @case (185) {
        <ng-container i18n>Ausprägung nicht definiert: Alternative „{{ ec2.args[0] }}“, Ziel „{{ ec2.args[1] }}“.</ng-container>
      }
    }
  }

  @if (ec3) {
    @switch (error.code) {
      @case (184) {
        <ng-container i18n
          >Ausprägung nicht vollständig definiert: Alternative „{{ ec3.args[0] }}“, Ziel „{{ ec3.args[1] }}“, Einflussfaktor Zustand „{{
            ec3.args[2]
          }}“.</ng-container
        >
      }
    }
  }
</p>
